module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.carregando) ? _c('div', {
    staticClass: "text-center p-4"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-2x"
  }), _vm._v(" Carregando registros...\n  ")]) : [(!_vm.estahVazio(_vm.registros)) ? _c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("Atualização Cadastral por ano e mês")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.registros), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.anoCompetencia))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.mesCompetencia))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.situacao))]), _vm._v(" "), _c('td', [_c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Visualizar'),
        expression: "'Visualizar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "visualizar"
      },
      on: {
        "clicado": function($event) {
          return _vm.visualizar(item.id)
        }
      }
    })], 1)])
  }), 0)])])])])])])])]) : _c('pagina-erro', {
    attrs: {
      "titulo": "Atualização Cadastral Encerrada",
      "icone": "fa fa-hourglass-end",
      "imagemTexto": "centralservidor-logo-texto.png",
      "imagem": "centralservidor-logo.png",
      "texto": "O período de atualização cadastral se encerrou. Caso ainda precise atualizar seus dados, dirija-se ao DEGEPAT."
    }
  })]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ano")]), _vm._v(" "), _c('th', [_vm._v("Mês")]), _vm._v(" "), _c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1148c66a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/recadastramento/mes-competencia-ordenado/index.vue
// module id = Obs4
// module chunks = 5